import { render, staticRenderFns } from "./RewardDetailEditor.vue?vue&type=template&id=79566511&scoped=true&"
import script from "./RewardDetailEditor.vue?vue&type=script&lang=js&"
export * from "./RewardDetailEditor.vue?vue&type=script&lang=js&"
import style0 from "./RewardDetailEditor.vue?vue&type=style&index=0&id=79566511&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79566511",
  null
  
)

export default component.exports